var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', $event.target.checked)
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708f004a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/checkbox.vue
// module id = null
// module chunks = 